import SouthIcon from '@mui/icons-material/South';
import { CircularButton } from './styles';

interface DownArrowButtonProps {
  onClick: () => void;
}

const DownArrowButton: React.FC<DownArrowButtonProps> = ({ onClick }) => {
  return (
    <CircularButton onClick={onClick}>
      <SouthIcon
        sx={{
          fontSize: {
            xs: '1.6rem',   // <= 620px
            sm: '2.3rem',   // > 620px
          },
        }}
      />
    </CircularButton>
  );
};

export default DownArrowButton;
